import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { scrollTo } from 'helpers/scrollTo';

export default function useHash() {
  const [hash, setHash] = useState('');
  const [element, setElement] = useState(null);

  const { hash: urlHash } = useLocation();

  const id = urlHash.replace('#', '');
  const el = document.getElementById(id);

  useEffect(() => {
    if (urlHash) setHash(urlHash);
  }, [urlHash]);

  useEffect(() => {
    if (el) setElement(el);
  }, [el]);

  useEffect(() => {
    if (urlHash && urlHash !== '' && element) {
      scrollTo(element, -150, 'smooth');
    }
  }, [urlHash, element]);

  return [hash, setHash]
}
